import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-inbox',
  templateUrl: './icon-inbox.component.html',
  styleUrls: ['./icon-inbox.component.scss']
})
export class IconInboxComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
